var React = require('react');

function Battleship (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Battleship"),React.createElement("path",{"id":"path875","className":"cls-1","d":"M21.64,114.83,55.53,80.94H72.47l33.89,33.89V55.53L64,13.17,21.64,55.53Z","key":2})]);
}

Battleship.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Battleship;

Battleship.default = Battleship;
